import App from './app.html';

const app = new App({
  target: document.body,
  props: {
    name: 'world'
  }
});

export default app;
